import { MultipleSelect } from '@app/components';

import { useUsers } from '@pages/Users/UsersList/hooks/useUsers';

import { PageHeader } from '@pages/Users/UsersList/components/PageHeader';

import { UsersList } from '@pages/Users/UsersList/UsersList.main';
import { adaptDataToTable } from '@pages/Users/UsersList/utils/adaptDataToTable';

export { UsersList, PageHeader, adaptDataToTable, useUsers, MultipleSelect };
